import { LOGIN_USER, REMOVE_TOKEN, REMOVE_USER, SET_TOKEN } from "../types";

const initialState = {
    user: null,
    isAuthenticated: false,
    token: null,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case LOGIN_USER: {
            return {
                ...state,
                user: action.user,
                isAuthenticated: true
            }
        }
        case REMOVE_USER: {
            return {
                ...state,
                user: null,
                isAuthenticated: false
            }
        }
        case SET_TOKEN: {
            // console.log("Action Payload: ", action.payload)
            return {
                ...state,
                token: action.payload
            }
        }
        case REMOVE_TOKEN: {
            return {
                ...state,
                token: null
            }
        }
        default: {
            return state
        }
    }
}
export default reducer